module.exports = __webpack_public_path__ + "img/govImg.6a83f8d9.png";